import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=70560662&scoped=true&"
import script from "./Billing.vue?vue&type=script&lang=js&"
export * from "./Billing.vue?vue&type=script&lang=js&"
import style0 from "./Billing.vue?vue&type=style&index=0&id=70560662&lang=scss&scoped=true&"
import style1 from "./Billing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70560662",
  null
  
)

export default component.exports